// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__2w9Vv","defaultInput":"Input_defaultInput__53R7z"};